import { Chip } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';

type ColumnGenerator = () => Partial<GridColDef>;
type ColumnMap = Record<string, ColumnGenerator>;

export const InternalAffairsAuditTrailsCols = (): ColumnMap => ({
  createdAt: () => ({
    field: 'createdAt',
    headerName: 'Created at',
    flex: 1,
    minWidth: 200,
    valueFormatter: (params) => {
      if (!params) return '';
      const date = new Date(params);
      return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    },
  }),
  event: () => ({
    field: 'event',
    headerName: 'Event',
    flex: 1,
    minWidth: 180,
    renderCell: (params) => {
      const getEventColor = (event: string) => {
        const colors: Record<
          string,
          'default' | 'primary' | 'success' | 'warning' | 'error' | 'info'
        > = {
          Create: 'success',
          Edit: 'primary',
          'Status changes': 'warning',
          'Permission grants': 'info',
          Deletions: 'error',
          'File upload': 'default',
          'Comment added': 'default',
          'Assignment change': 'primary',
        };
        return colors[event] || 'default';
      };

      return (
        <Chip
          label={params.value}
          size="small"
          color={getEventColor(params.value)}
        />
      );
    },
  }),
  field: () => ({
    field: 'field',
    headerName: 'Field',
    flex: 1,
    minWidth: 180,
  }),
  value: () => ({
    field: 'value',
    headerName: 'Value',
    flex: 1,
    minWidth: 300,
  }),
  changedBy: () => ({
    field: 'changedBy',
    headerName: 'Changed by',
    flex: 1,
    minWidth: 200,
  }),
  triggeredBy: () => ({
    field: 'triggeredBy',
    headerName: 'Triggered by',
    flex: 1,
    minWidth: 200,
  }),
});
